import installationInstructions from './installationInstructions';

const peyBulbContent = {
  installationInstructions
}

export { peyBulbContent };
